import { useState, useEffect } from "react";
import { Card } from "@/components/ui/Card";
import { Input } from "@/components/ui/Input";
import { Button } from "@/components/ui/Button";
import { useTheme } from "@/lib/theme";
import { useToast } from "@/hooks/useToast";

export default function Settings() {
  const { theme, setTheme } = useTheme();
  const { push } = useToast();
  const [key, setKey] = useState("");

  useEffect(() => {
    setKey(localStorage.getItem("apiKey") ?? "");
  }, []);

  function save() {
    localStorage.setItem("apiKey", key);
    push({ message: "Klucz API zapisany", tone: "success" });
  }

  return (
    <div className="max-w-md flex flex-col gap-4">
      <Card>
        <h2 className="text-lg font-semibold mb-3">Klucz API</h2>
        <div className="flex flex-col gap-2">
          <Input
            id="api-key"
            type="password"
            label="X-API-Key"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            hint="Zapisywany lokalnie w przeglądarce"
          />
          <div><Button onClick={save}>Zapisz</Button></div>
        </div>
      </Card>

      <Card>
        <h2 className="text-lg font-semibold mb-3">Motyw</h2>
        <div className="flex gap-2">
          <Button variant={theme === "light" ? "primary" : "secondary"} onClick={() => setTheme("light")}>Jasny</Button>
          <Button variant={theme === "dark" ? "primary" : "secondary"} onClick={() => setTheme("dark")}>Ciemny</Button>
        </div>
      </Card>
    </div>
  );
}
